import { type GetLayout } from '@/typings/NextJS';

const getNoLayout: GetLayout = (page) => page;

export default getNoLayout;
